import React , { Component } from 'react';
import styled, { css, keyframes } from 'react-emotion';
import { screenWidths } from './../../utils/constants';

const Info = styled.div`
    width: 100%;
`;

export const Title = styled.h2`
  font-family: ZeitungMicroPro-Light;
  font-weight: normal;
  margin-bottom: 55px;
  font-size: 50px;
  color:  #424149;
  @media screen and (min-width: ${screenWidths.lg}px) {
    text-align: left;
  }
`;

const LiderContainer = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center
`;


const LiderMemberContainer = styled.div`
  text-align: center;
  width: 500px;

  .imgLider{
    width: 500px;
    height: 312.85px;
    min-width: 312.85px;
    object-fit: cover;
  }

  p {
    margin: 0px 0px 20px 0px;
    font-family: ZeitungMicroPro-Light;
    span {
      font-family: ZeitungMicroPro-Bold;
    }
  }
`;

const TeamContainer = styled.div`
  display: grid;
  grid-column-gap: 40px;
  width: 100%;
  @media screen and (min-width: ${screenWidths.lg}px) {
    grid-template-columns: repeat(3, .5fr);
  }
`;

const TeamMemberContainer = styled.div`
  text-align: center;

  .imgTeam{
    width: 312.85px;
    height: 312.85px;

    margin-top:40px;
    object-fit: cover;
  }

  p {
    margin: 0px 0px 20px 0px;
    font-family: ZeitungMicroPro-Light;
    span {
      font-family: ZeitungMicroPro-Bold;
    }
  }
`;

const TeamContainerAlt = styled.div`
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  @media screen and (min-width: ${screenWidths.lg}px) {


  }
`;

const TeamMemberContainerAlt = styled.div`
  text-align: center;
  width:29%;
  margin:2% !important;
  float:left;
  margin: 0 auto;
  margin-left: 16vw !important;

  @media screen and (max-width: 575px) {

    width:100% !important;
    margin:0 !important;
    margin-left: 0 !important;
  }

  @media screen and (min-width: 1564px) {

      margin-left: -10vw !important;
  }

  @media screen and (min-width: 1576px) {

      margin-left: 10vw !important;
  }

  @media screen and (min-width: 1718px) {

      margin-left: 10vw !important;
  }

  @media screen and (min-width: 1736px) {

      margin-left: 10vw !important;
  }

  @media screen and (min-width: 1740px) {

      margin-left: 10vw !important;
  }

  @media screen and (min-width: 1800px) {

      margin-left: -10vw !important;
  }

  @media screen and (min-width: 1920px) {

      margin-left: 10vw !important;
  }


  .imgTeam{
    width: 312.85px;
    height: 312.85px;

    margin-top:40px;
    object-fit: cover;
  }

  p {
    margin: 0px 0px 20px 0px;
    font-family: ZeitungMicroPro-Light;
    span {
      font-family: ZeitungMicroPro-Bold;
    }
  }
`;

const TeamMemberContainerAltLeft = styled.div`
  text-align: center;
  width:29%;
  margin:2% !important;
  float: left;
  margin: 0 auto;


  @media screen and (max-width: 575px) {

    width:100% !important;
    margin:0 !important;
    margin-left:0 !important;
  }

  .imgTeam{
    width: 312.85px;
    height: 312.85px;

    margin-top:40px;
    object-fit: cover;
  }

  p {
    margin: 0px 0px 20px 0px;
    font-family: ZeitungMicroPro-Light;
    span {
      font-family: ZeitungMicroPro-Bold;
    }
  }
`;

const LiderMember = ({ picture, fullName, jobTitle, description,id}) => {
  return (
    <LiderMemberContainer>
      <img className={"imgLider"} src={picture.file.url} />
      <p>{fullName}<br/><span>{jobTitle}</span></p>
      <p>{description.description}</p>
    </LiderMemberContainer>
  )
};

const TeamMember = ({ picture, fullName, jobTitle, description,id}) => {
    return (
      <TeamMemberContainer>
        <img className={"imgTeam"} src={picture.file.url} />
        <p>{fullName}<br/><span>{jobTitle}</span></p>
        <p>{description.description}</p>
      </TeamMemberContainer>
    )
  };

const TeamMemberAlt = ({ picture, fullName, jobTitle, description,id}) => {
  return (
    <TeamMemberContainerAlt>
      <img className={"imgTeam"} src={picture.file.url} />
      <p>{fullName}<br/><span>{jobTitle}</span></p>
      <p>{description.description}</p>
    </TeamMemberContainerAlt>
  )
};

const TeamMemberAltLeft = ({ picture, fullName, jobTitle, description,id}) => {
    return (
      <TeamMemberContainerAltLeft>
        <img className={"imgTeam"} src={picture.file.url} />
        <p>{fullName}<br/><span>{jobTitle}</span></p>
        <p>{description.description}</p>
      </TeamMemberContainerAltLeft>
    )
  };

export default class Equipo extends Component {
    render() {
        return (
                <Info>
                    <Title>{this.props.title}</Title>

                    <LiderContainer>
                        {this.props.team.map((t,idx) => idx==0 && <LiderMember key={t.id} {...t} />)}
                    </LiderContainer>

                    {(this.props.team.length-1)%3 == 0 &&
                      <TeamContainer>
                          {this.props.team.map((t,idx) => idx!=0 && <TeamMember key={t.id} {...t} />)}
                      </TeamContainer>
                    }



                    {(this.props.team.length-1)%3 !== 0 &&
                      <TeamContainerAlt>
                          {this.props.team.map((t,idx) => idx!=0 &&
                            idx !=4 ?
                              <TeamMemberAltLeft key={t.id} {...t} />
                            :
                            idx != 0 ?
                            <TeamMemberAlt key={t.id} {...t} />
                            :
                            console.log(idx)
                          )}
                      </TeamContainerAlt>
                    }

                </Info>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/About/Equipo.js